import { Button } from '../components/ui/button';
import { useContactInfo } from '../hooks/useContactInfo';
import { useTranslation } from '../i18n/I18nContext';
import Reveal from './shared/Reveal';
import './page-layout.css';
import './about.css';

/**
 * «О нас».
 *
 * ## Что здесь было и почему это переписано целиком (#1330)
 *
 * Страница описывала другого дилера: «Cool Cars Amsterdam», основан в 2009,
 * два салона в Амстердаме. Легенда витрины — ShiftGears Motors, Кипр и
 * Люксембург, и текст ей прямо противоречил.
 *
 * Кроме легенды выброшено три блока:
 *
 * - **«Our track record»** — «5000+ проданных авто», «15+ лет опыта», «98%
 *   довольных клиентов». Ни одно из этих чисел ничем не подтверждается. На
 *   публичной витрине, которую показывают дилерам, придуманная статистика
 *   доверия — худшее, что можно написать: её первым делом и проверяют.
 *   Полосу настоящих чисел (`DealerFacts`, снят в #1335) здесь пробовали, и
 *   на «О нас» она читалась повтором главной. Страница
 *   держится на том, что проверяемо словами: кто мы, как устроена покупка,
 *   где нас найти.
 * - **«Meet our team»** — три выдуманных человека с пустыми серыми кружками
 *   вместо фотографий. Выдуманные люди с именами и должностями — это уже не
 *   заглушка, а вымысел о конкретных персонах.
 * - **«Our values»** — «Transparency / Quality / Service» карточками. Ровно
 *   тот же жанр общих слов, который убран с главной: ни одного проверяемого
 *   утверждения.
 *
 * ## Чем заменено
 *
 * Тем, что есть на сайтах европейских дилеров и что здесь правда: кто мы,
 * как устроена покупка (шаги), настоящие числа по стоку, салоны с картами.
 * Плюс честная строка о том, что это витрина возможностей, а не работающий
 * автосалон, — она защищает от того же вымысла лучше, чем его отсутствие.
 */

/** Почта ShiftGears: письма о продукте идут нам, а не демо-салону. */
const SHIFTGEARS_EMAIL = 'info@shiftgears.ai';

const AboutPage = () => {
  const contactInfo = useContactInfo();
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="page__container">

        <div className="about__layout">
          {/* Слева — прямое заявление и один призыв к действию. Заголовок
              страницы И ЕСТЬ «это витрина»: тратить его на «About Demo
              Motors» значило бы представлять вымышленный салон вместо того,
              что мы на самом деле показываем. */}
          <div className="about__intro">
            <h1 className="about__title">{t('showcase.company.title', 'This is a showcase')}</h1>

            <blockquote className="about__claim">
              {t('showcase.company.claim', '').replace('{company}', contactInfo.company.name)}
            </blockquote>

            {/* Почта ShiftGears, а не форма витрины: сюда пишут про продукт, а
                не про машину, и вести такое письмо в демо-салон бессмысленно.
                `as="a"`: это переход, а `<a>` вокруг `<button>` — вложенные
                интерактивные элементы, читалка видела два. */}
            <Button
              as="a"
              size="lg"
              arrow
              className="about__cta"
              href={`mailto:${SHIFTGEARS_EMAIL}`}
            >
              {t('showcase.company.cta', 'Contact us')}
            </Button>
          </div>

          {/* Справа — кто мы. Колонкой на карточке: это справка о компании, а
              не продолжение заявления слева.

              Текст собран из того, что уже написано на shiftgears.ai (секции
              About, WhyUs, Solutions), а не сочинён здесь: витрина не должна
              расходиться с сайтом компании, и выдуманных утверждений о себе
              на ней уже хватило одного раза. Цифр нет намеренно. */}
          {/* Плитка (#1335, вариант «A» с холста) со своим заголовком
              — ключ `whoTitle` давно есть в переводах, просто не выводился:
              без него правая колонка читалась продолжением заявления.
              Последняя фраза — вывод плитки, крупнее абзацев. */}
          <Reveal as="aside" className="about__company">
            <h2 className="about__company-title">
              {t('showcase.company.whoTitle', 'Who is behind this')}
            </h2>
            <p>{t('showcase.company.who1', '')}</p>
            <p>{t('showcase.company.who2', '')}</p>
            <p className="about__company-close">
              {t('showcase.company.who3', '')}
            </p>
          </Reveal>
        </div>

      </div>
    </div>
  );
};

export default AboutPage;
